(function () {
  angular.module('imnApp').controller('ConsoleWebController', ConsoleWebController);

  ConsoleWebController.$inject = [
    '$scope',
    '$uibModalInstance',
    '$document',
    '$timeout',
    'ConsoleWebService',
    'ConsoleHistoryService',
    'RequestService',
    'OltData'
  ];

  function ConsoleWebController(
    $scope,
    $uibModalInstance,
    $document,
    $timeout,
    ConsoleWebService,
    ConsoleHistoryService,
    RequestService,
    OltData
  ) {
    var vm = this;
    var oltId = OltData.detail.id;
    var defaultPrompt = '';
    var MORE_PAGINATION = '--More--';

    vm.input = '';
    vm.content = '';
    vm.prompt = '';
    vm.requestRunning = false;
    vm.autoFocus = false;
    vm.autoScroll = false;

    vm.sendCommand = sendCommand;
    vm.disconnect = disconnect;
    vm.verifyMouseEvent = verifyMouseEvent;

    $uibModalInstance.rendered.then(function () {
      vm.autoFocus = true;
      sendCommand({ which: 13 });
    });

    // Actions
    function sendCommand(keyEvent) {
      switch (keyEvent.which) {
        case 13:
          if ((vm.input == 'exit' || vm.input == 'logout') && vm.prompt === defaultPrompt) {
            ConsoleWebService.disconnect(oltId).finally(close);
          } else {
            vm.requestRunning = true;
            vm.autoFocus = false;
            vm.autoScroll = false;
            if (vm.input && vm.prompt === defaultPrompt) {
              ConsoleHistoryService.add(vm.input);
            }
            ConsoleWebService.sendCommand(oltId, vm.input || ' ')
              .then(successSend)
              .catch(errorSend);
          }
          break;
        case 38:
          vm.input = ConsoleHistoryService.prev();
          break;
        case 40:
          vm.input = ConsoleHistoryService.next();
          break;
      }
    }

    function disconnect() {
      RequestService.cancelRequests(['olts/console/' + oltId + '/sendcmd']);
      ConsoleWebService.disconnect(oltId).finally(close);
    }

    function verifyMouseEvent() {
      var textIsSelected = $document[0].getSelection().toString();
      vm.autoFocus = false;
      if (!textIsSelected.trim()) {
        $timeout(function () {
          vm.autoFocus = true;
        });
      }
    }

    // Request callbacks
    function successSend(data) {
      if (data.includes(MORE_PAGINATION)) {
        vm.content += vm.prompt + data.replace(/ *$/, '').replace(MORE_PAGINATION, '');
        vm.prompt = MORE_PAGINATION;
        ConsoleWebService.sendCommand(oltId, 'r').then(successSend).catch(errorSend);
        return;
      }

      if (vm.prompt === MORE_PAGINATION) {
        vm.prompt = '';
        data = data.trim() + ' ';
      }

      var pos = data.lastIndexOf('\n');
      var content = vm.prompt + data.substring(0, pos) + '\n';
      var prompt = data.substring(pos + 1);

      if (!vm.prompt) {
        defaultPrompt = prompt;
      }
      vm.content += content;
      vm.prompt = prompt;
      vm.input = '';

      vm.requestRunning = false;
      vm.autoFocus = true;
      vm.autoScroll = true;
    }

    function errorSend(response) {
      vm.requestRunning = false;
      vm.autoFocus = true;
      ConsoleWebService.errorModalConstructor(response, 'sendCommand');
      close();
    }

    function close() {
      $uibModalInstance.dismiss('cancel');
    }
  }
})();
